import { useRouteMatch } from 'react-router';

export function useTrainingUrl() {
  return useRouteMatch({
    path: '/l/:learnerId/t/:learnerTrainingId'
  })?.url;
}
